// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.spinner{height:2rem;margin:.25rem auto;width:2rem}`, "",{"version":3,"sources":["webpack://./Components/src/components/common/LoadingSpinner/styles/loadingSpinner.scss"],"names":[],"mappings":"AAAA,SAGE,WAAA,CAFA,kBAAA,CACA,UAEF","sourcesContent":[".spinner {\n  margin: 0.25rem auto;\n  width: 2rem;\n  height: 2rem;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
